// `public/index.html` `/settings` isteğini paket inmeden başlatır ve sözü
// `window.__bhsSettingsPrefetch` alanına koyar: açılış ekranı markayı önbellek
// boşken de çizebilsin (ilk ziyaret, yeni alan adı) ve istek telefonda
// saniyeler süren paket indirmesiyle paralel yürüsün. SettingsContext aynı
// cevabı ikinci kez istemez; sözü buradan **bir kez** alır — sonraki
// tazelemeler (30 sn turu, sekmeye dönüş) her zaman sunucuya gider. Alan adı
// index.html'deki betikle aynı kalmalıdır.
export const SETTINGS_PREFETCH_KEY = '__bhsSettingsPrefetch';

export const takeSettingsPrefetch = (win = typeof window !== 'undefined' ? window : null) => {
  const request = win?.[SETTINGS_PREFETCH_KEY];
  if (!win || !request || typeof request.then !== 'function') return null;
  win[SETTINGS_PREFETCH_KEY] = null;
  return request;
};

// Önden alınmış cevabı çözer. Başarısız ya da biçimsiz cevap `null` döner ve
// çağıran taraf olağan isteği yapar: ön istek bir hızlandırmadır, ayarların
// tek kaynağı değildir — onun hatası kesinti ekranı da açmamalıdır.
export const readSettingsPrefetch = async (win) => {
  const request = takeSettingsPrefetch(win);
  if (!request) return null;
  try {
    const data = await request;
    return data && typeof data === 'object' && !Array.isArray(data) ? data : null;
  } catch {
    return null;
  }
};
